<template>
  <Form
    class="form"
    :class="[`form-${block}`, isEditForm ? 'form--bg' : '']"
    @request="constructingSubmit"
    v-model="modelFormData"
  >
    <div
      class="form__inputs"
      :class="`form-${block}__inputs`"
    >
      <VSelect
        label="Вид документа"
        placeholder="Выбрать"
        name="document"
        item-text="name"
        :items="documentList"
      />
      <VInput name="topic" label="Тема" />
      <VInput name="number" label="№ документа" />
      <AppInputDate
        name="dateRegistration"
        title="Дата регистрации"
      />
      <VSelect
        label="Исполнитель"
        placeholder="Выбрать"
        name="executor"
        item-text="name"
        :items="executorList"
      />
      <VSelect
        label="Ответственный"
        placeholder="Выбрать"
        name="supervisor"
        item-text="name"
        :items="supervisorList"
      />
      <AppInputFile
        class="form__input--col-2"
        title="Загрузите файл"
        @value-changed="upload"
        name="uploadFilesList"
        :value="uploadFiles"
        @delete-file="() => {}"
      />
    </div>

    <div
      class="form__buttons"
      :class="`form-${block}__buttons`"
    >
      <AppButton :title="setBtnSubmitText" type="main" />
      <AppButton title="Отмена" type="alt" @click.native.prevent="() => $emit('cancel')" />
    </div>
  </Form>
</template>

<script>
import AppButton from '@/components/page/button/AppButton.vue'
import Form from '@/components/page/Form/Form.vue'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import VSelect from '@/components/page/Form/VSelect.vue'
import AppInputDate from '@/components/page/input/AppInputDate'
import AppInputFile from '@/components/page/input/AppInputFile'
import { MOCKS_CONTRACT, MOCKS_EXECUTORS, MOCKS_SUPERVISOR } from '@/mocks/select-mock'

export default {
  props: {
    block: {
      type: String,
      default: 'modal'
    },
    formData: {
      type: Object,
      default: () => {}
    },
    isEditForm: {
      type: Boolean,
      default: false
    }
  },

  model: {
    prop: 'formData',
    event: 'changeFormData'
  },

  data: () => ({
    uploadFilesList: [],

    // заглушка для селекта
    supervisorList: MOCKS_SUPERVISOR,
    documentList: MOCKS_CONTRACT,
    executorList: MOCKS_EXECUTORS
  }),

  computed: {

    uploadFiles () {
      console.log(this.formData)
      if (this.formData) {
        return this.formData.uploadFiles
      }
      return this.uploadFilesList
    },

    setBtnSubmitText () {
      return this.isEditForm ? 'Сохранить' : 'Создать'
    },

    modelFormData: {
      get () {
        return this.formData
      },
      set (val) {
        this.$emit('changeFormData', val)
      }
    }
  },

  methods: {
    constructingSubmit (data) {
      this.$emit('constructingSubmit', data)
    },

    upload (files) {
      console.log(files)
      if (this.formData) {
        this.formData.uploadFiles = files
      } else {
        this.uploadFilesList = files
      }
    }
  },

  components: {
    AppButton,
    Form,
    VInput,
    VSelect,
    AppInputDate,
    AppInputFile
  }
}
</script>
